import { Application } from '@intellio/shared/models';
import { FormlyFieldConfig } from '@ngx-formly/core';
import type { FormlyHookFn } from './formly-hook-fn.type';
import { setupInterpolation } from './form-hooks.utility';

export const interpolateStringHook = (
  functionName,
  application: Application
): FormlyHookFn => {
  return (field: FormlyFieldConfig) => {
    setupInterpolation(functionName, application, field, false);
  };
};
